module.exports = __webpack_public_path__ + "img/201911.c2c025dd.jpg";